import ImageWithFallback from '@/components/ImageWithFallback';
import LimitedLineText from '@/components/Module/LimitedLineText';
import useViewport from '@/hooks/useViewport';

export type EventListItemProps = {
  venueName: string;
  title: string;
  itinerary: string;
  imageUrl: string;
  cancelled: boolean;
  id: string;
};

const MobileEventListItem = (props: EventListItemProps) => {
  const { venueName, imageUrl, title, itinerary, cancelled } = props;

  return (
    <div className={`flex w-full items-center gap-[16px]`}>
      <div className={`h-[80px] shrink-0 grow-0 basis-[80px]`}>
        <ImageWithFallback
          key={imageUrl}
          placeholder="blur"
          blurDataURL={imageUrl}
          width={80}
          height={80}
          src={imageUrl}
          alt={`${title} image`}
          className={`rounded-[12px] object-cover`}
        />
      </div>
      <div className={`flex flex-col gap-[4px]`}>
        <p className={`font-roboto text-c2 font-normal text-gray-200`}>
          {venueName}
        </p>
        <LimitedLineText
          lineCount={2}
          className={`font-roboto text-h5 font-normal`}
        >
          {title}
        </LimitedLineText>
        {cancelled ? (
          <p className={`font-roboto text-b3 font-normal text-danger-red-100`}>
            Event was Cancelled
          </p>
        ) : (
          <p className={`font-roboto text-b3 font-normal text-green-200`}>
            {itinerary}
          </p>
        )}
      </div>
    </div>
  );
};
const DesktopEventListItem = (props: EventListItemProps) => {
  const { venueName, imageUrl, title, itinerary, cancelled } = props;

  return (
    <div className={`flex w-full items-center gap-[32px]`}>
      <div className={`h-[128px] shrink-0 grow-0 basis-[128px]`}>
        <ImageWithFallback
          key={imageUrl}
          placeholder="blur"
          blurDataURL={imageUrl}
          width={128}
          height={128}
          src={imageUrl}
          alt={`${title} image`}
          className={`rounded-[12px] object-cover`}
        />
      </div>
      <div className={`flex flex-col gap-[4px]`}>
        <p className={`font-roboto text-b2 font-normal text-gray-200`}>
          {venueName}
        </p>
        <LimitedLineText
          lineCount={2}
          className={`font-roboto text-h4 font-medium`}
        >
          {title}
        </LimitedLineText>
        {cancelled ? (
          <p className={`font-roboto text-h4 font-normal text-danger-red-100`}>
            Event was Cancelled
          </p>
        ) : (
          <p className={`font-roboto text-h4 font-normal text-green-200`}>
            {itinerary}
          </p>
        )}
      </div>
    </div>
  );
};
const EventListItem = (props: EventListItemProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile` || viewport == `tablet`) {
    return <MobileEventListItem {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopEventListItem {...props} />;
  }

  return null;
};

export default EventListItem;
